// extracted by mini-css-extract-plugin
export var button = "TextButton-module--button--c67d4";